import { Grid, GridRecord } from '@/components/blocks/DesignSystem/Grid'
import { GridBlock, GridBlockRecord } from '@/components/blocks/DesignSystem/GridBlock'
import { SpacerBlock } from '@/components/blocks/DesignSystem/Spacer'
import { ImageBentoGrid } from '@/components/blocks/DesignSystem/ImageBentoGrid'
import { VideoCoverBlock, VideoCoverRecord } from '@/components/blocks/DesignSystem/VideoCoverBlock'
import { JumboTitleBlock, JumboTitleRecord } from '@/components/blocks/Shared/JumboTitleBlock'
import { CardsBlock, CardsSectionRecord } from '@/components/blocks/Shared/CardsBlock'
import { DividerBlock } from '@/components/blocks/DesignSystem/DividerBlock'
import { AppDownloadBlock, AppDownloadSectionRecord } from '@/components/blocks/Shared/AppDownloadBlock'
import { PodcastBlock, PodcastBlockRecord } from '@/components/blocks/Shared/PodcastBlock'
import { ContentAndImageBlock, ContentAndImageBlockRecord } from '@/components/blocks/Shared/ContentAndImageBlock'
import { VideoFullWidthBlock, VideoFullWidthRecord } from '@/components/blocks/Shared/VideoFullWidthBlock'
import { InfoSurfaceBlock, InfoSurfaceBlockRecord } from '@/components/blocks/Shared/InfoSurfaceBlock'
import { DividerRecord, ImageBentoGridRecord, SpacerRecord } from 'types'

export type ModularContentBlocks =
  | SpacerRecord
  | GridRecord
  | GridBlockRecord
  | ImageBentoGridRecord
  | VideoCoverRecord
  | JumboTitleRecord
  | CardsSectionRecord
  | DividerRecord
  | AppDownloadSectionRecord
  | ContentAndImageBlockRecord
  | VideoFullWidthRecord
  | InfoSurfaceBlockRecord
  | PodcastBlockRecord

export const renderModularBlocks = (record, index) => {
  const key = `${record.id}-${index}}`
  switch (record.__typename) {
    case 'GridRecord':
      return <Grid key={key} record={record} />
    case 'GridBlockRecord':
      return <GridBlock key={key} record={record} />
    case 'SpacerRecord':
      return <SpacerBlock key={key} record={record} />
    case 'ImageBentoGridRecord':
      return <ImageBentoGrid key={key} record={record} />
    case 'VideoCoverRecord':
      return <VideoCoverBlock key={key} record={record} />
    case 'JumboTitleRecord':
      return <JumboTitleBlock key={key} record={record} />
    case 'CardsSectionRecord':
      return <CardsBlock key={key} record={record} />
    case 'DividerRecord':
      return <DividerBlock key={key} record={record} />
    case 'AppDownloadSectionRecord':
      return <AppDownloadBlock key={key} record={record} />
    case 'PodcastSectionRecord':
      return <PodcastBlock key={key} record={record} />
    case 'ContentAndImageSectionRecord':
      return <ContentAndImageBlock key={key} record={record} />
    case 'VideoFullWidthRecord':
      return <VideoFullWidthBlock key={key} record={record} />
    case 'InfoSurfaceRecord':
      return <InfoSurfaceBlock key={key} record={record} />
  }
}
